import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    template: require('./propertydetailsRemoveDialog.component.html')
})
export class PropertydetailsRemoveDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<PropertydetailsRemoveDialog>) public dialogRef: MatDialogRef<PropertydetailsRemoveDialog>) {}

    closeThisDialog(value: any){
        this.dialogRef.close(value)
    }
}
